export default "__VITE_ASSET__8a786133__"